<script setup></script>

<template>
  <div class="loading-bg">
    <div class="loader">
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:math';
@use 'sass:color';

html,
body {
  height: 100%;
}

body {
  align-items: center;
  background: #f8f7fd;
  display: flex;
  justify-content: center;
}

$dot-count: 26;
$dot-size: 10px;
$dot-space: 15px;
$dot-start: calc(($dot-count / 2 + 1) * ($dot-size + $dot-space) / 2);

$animation-time: 2s;
$animation-distance: 25px;

.loading-bg {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(var(--v-theme-card-background));
  position: fixed;
  z-index: 9999999;
}

.loader {
  position: relative;
  width: auto;
  height: auto;

  .dot {
    animation-name: movement;
    animation-duration: $animation-time;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    will-change: transform, opacity;
    height: $dot-size;
    position: absolute;
    top: calc(-1 * #{$dot-size});
    transform: translate3d(0, calc(-1 * #{$animation-distance}), 0) scale(1);
    width: $dot-size;

    @for $i from 1 through $dot-count {
      $dot-move: math.div($i, 2);
      $dot-move: math.ceil($dot-move);
      $dot-pos: calc($dot-start - (($dot-size + $dot-space) * $dot-move));

      $animation-delay: calc(-1 * $i * 0.1s);
      @if $i % 2 == 0 {
        $animation-delay: calc(-1 * $i * 0.1s + $animation-time / 2);
      }

      &:nth-of-type(#{$i}) {
        animation-delay: $animation-delay;
        left: $dot-pos;

        &::before {
          animation-delay: $animation-delay;
        }
      }
    }

    &::before {
      animation-name: size-opacity;
      animation-duration: $animation-time;
      animation-iteration-count: infinite;
      animation-timing-function: ease;
      will-change: transform, opacity;
      background: #482bd9;
      border-radius: 50%;
      content: '';
      display: block;
      height: 100%;
      width: 100%;
    }

    &:nth-of-type(even)::before {
      background-color: #f8961e;
      box-shadow: inset 0 0 4px color.adjust(#ff47aa, $lightness: -10%);
    }
  }
}

@keyframes movement {
  0% {
    transform: translate3d(0, calc(-1 * #{$animation-distance}), 0);
  }
  50% {
    transform: translate3d(0, #{$animation-distance}, 0);
  }
  100% {
    transform: translate3d(0, calc(-1 * #{$animation-distance}), 0);
  }
}

@keyframes size-opacity {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  25% {
    transform: scale(1.5);
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 0.35;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
